export class MockStore {
  get isMockMode(): boolean {
    return false;
  }

  set isMockMode(value: boolean) {}
}

// NOTE: It can't be static due to: https://github.com/mobxjs/mobx/issues/351
export const mockStore = new MockStore();



// WEBPACK FOOTER //
// ./app/stores/mockStore/mockStore.ts